export const ColumnSortingOrder = {
  ASC: "ASC",
  DESC: "DESC",
} as const
export type ColumnSortingOrder = (typeof ColumnSortingOrder)[keyof typeof ColumnSortingOrder]
